<script setup lang="ts">
const steps = [
  {
    step: 1,
    title: 'Dibuat',
    description: '10 Oktober 2025, 13:58',
    icon: 'material-symbols:check',
    completed: true
  },
  {
    step: 2,
    title: 'Diproses',
    description: '10 Oktober 2025, 14:00',
    icon: 'material-symbols:check',
    completed: true
  },
  {
    step: 3,
    title: 'RTS',
    description: '08 Oktober 2025, 18:56',
    icon: 'material-symbols:check',
    completed: false
  },
  {
    step: 4,
    title: 'Retur Selesai',
    description: '10 Oktober 2025, 15:20',
    icon: 'material-symbols:hourglass-empty',
    completed: false
  }
]
</script>

<template>
  <UiEffectMarquee
    class="py-3 mt-3 lg:mt-10"
    track-class="gap-4"
    copy-class="gap-4"
  >
    <div class="aspect-[700/316] h-80 space-y-2.5">
      <UiCard header-class="flex justify-between py-3">
        <template #header>
          <div class="flex gap-[0.625rem] items-center">
            <div
              class="p-1 rounded-full bg-warning-container text-warning shrink-0"
            >
              <Icon name="material-symbols:deployed-code-alert" size="24px" />
            </div>
            <div class="grow">
              <p class="text-onSurface text-xs font-medium">Status Paket</p>
              <div
                class="flex gap-1 items-center font-semibold text-warning pointer text-sm"
              >
                RTS Finish
              </div>
            </div>
          </div>
          <div>
            <p class="text-onSurface text-xs font-medium text-right">
              Payment ID
            </p>
            <div class="flex gap-1 items-center text-sm font-semibold">
              <span>PTD65*********</span>
            </div>
          </div>
        </template>

        <UiStepper
          :options="steps"
          :model-value="3"
          item-class="justify-start"
        />
      </UiCard>
      <div class="flex gap-3 items-start">
        <UiCard
          class="divide-none w-4/6 bg-gradient-to-r from-warning-container to-background"
          header-class="bg-warning rounded-xl text-on-primary flex justify-between py-3.5 px-4"
          body-class="relative"
        >
          <template #header>
            <div class="flex gap-2 items-center">
              <div class="p-1 rounded-full bg-on-warning text-warning shrink-0">
                <Icon name="ka-icon:package-claim-fill" size="20px" />
              </div>
              <span>Klaim Paket</span>
            </div>
            <UiBadge
              label="Diproses"
              variant="warningYellow"
              icon="material-symbols:timer-outline"
            />
          </template>
          <p class="font-semibold text-sm">Pengiriman Tidak Sesuai?</p>
          <p class="text-sm">Yuk ajukan proses klaim sekarang</p>
          <svg
            class="absolute left-0 right-0 bottom-0"
            width="484"
            height="56"
            viewBox="0 0 484 56"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g style="mix-blend-mode: darken" opacity="0.5">
              <path
                d="M0 33.7738L111.787 56L266.353 50.0329C286.125 49.2696 305.238 42.7184 321.321 31.192C348.543 11.6822 383.662 6.92725 415.092 18.4961L484 43.8601V56H0V33.7738Z"
                fill="#E9C4B2"
              />
              <path
                d="M0 46.4745L109.944 53.931L167.516 55.0084C202.766 55.6681 238.002 53.0903 272.78 47.3076C333.758 37.1686 395.969 36.9103 457.029 46.5425L484 50.7972V56H0V46.4745Z"
                fill="#FBEAE2"
              />
            </g>
          </svg>
        </UiCard>
        <UiCard class="flex-1" body-class="flex flex-col gap-3 items-start">
          <div class="bg-secondary-container p-2 rounded-full text-primary">
            <Icon name="material-symbols:undo" size="20px" />
          </div>
          <div class="grow space-y-1">
            <div class="text-xs">Kendala Pengiriman</div>
            <div class="font-semibold">200</div>
          </div>
        </UiCard>
      </div>
    </div>
    <UiCard
      class="bg-on-primary-container text-on-primary h-80 aspect-square"
      body-class="flex flex-col justify-between h-full"
    >
      <div>
        <div
          class="bg-secondary-container mb-4 rounded-full inline-flex p-2 text-primary"
        >
          <Icon name="material-symbols:history-toggle-off" size="32px" />
        </div>
        <div class="font-semibold text-lg mb-2">Undelivery</div>
        <p>
          Fitur ini memungkinkan sistem untuk mengecek paket yang gagal terkirim
          sebelum dilakukan retur
        </p>
      </div>
      <div
        class="bg-on-primary mt-auto text-primary flex justify-between px-3.5 py-2 font-semibold rounded-xl"
      >
        <span>Support 24 Jam </span>
        <div class="flex gap-1 items-center">
          <span class="w-2.5 h-2.5 bg-primary-container rounded-full"></span>
          <span class="w-4 h-4 bg-primary rounded-full"></span>
          <span class="w-6 h-6 bg-on-primary-container rounded-full"></span>
        </div>
      </div>
    </UiCard>
    <div class="aspect-[500/316] h-80 space-y-3.5">
      <div class="grid grid-cols-2 gap-3">
        <UiCard body-class="flex gap-3 items-start">
          <div class="bg-secondary-container p-2 rounded-full text-primary">
            <Icon name="material-symbols:accessibility-new" size="24px" />
          </div>
          <div class="grow space-y-1">
            <div class="text-xs">Total Retur</div>
            <div class="font-semibold">3</div>
          </div>
        </UiCard>
        <UiCard body-class="flex gap-3 items-start">
          <div class="bg-secondary-container p-2 rounded-full text-primary">
            <Icon name="material-symbols:running-with-errors" size="24px" />
          </div>
          <div class="grow space-y-1">
            <div class="text-xs">Kendala Pengiriman</div>
            <div class="font-semibold">30</div>
          </div>
        </UiCard>
      </div>

      <UiCard>
        <div class="flex gap-3">
          <div
            class="bg-secondary-container flex-1 flex items-center text-xl lg:text-2xl font-semibold text-on-primary-container p-4 lg:p-5 rounded-xl"
          >
            Kelola Retur Dengan Efisien
          </div>
          <div class="w-4/6">
            <div class="bg-primary rounded-xl p-3.5 space-y-3 mb-3 grow">
              <div class="flex gap-3 items-center">
                <UiBadge
                  icon="material-symbols:moped"
                  label="Paket Diambil Sendiri"
                  size="lg"
                  variant="primaryContainer"
                />
                <span
                  class="w-4 block shrink-0 h-4 bg-on-primary-container/80 rounded-full"
                ></span>
                <UiBadge
                  icon="material-symbols:package-2"
                  label="RTS"
                  size="lg"
                  variant="primaryContainer"
                />
              </div>
              <div class="flex gap-3 items-center">
                <UiBadge
                  icon="material-symbols:package-2"
                  label="RTS"
                  size="lg"
                  variant="primaryContainer"
                />
                <span
                  class="w-1 block shrink-0 h-6 bg-on-primary-container/80 rounded-full"
                ></span>
                <UiBadge
                  icon="material-symbols:check-circle"
                  label="Paket Sudah Diterima"
                  size="lg"
                  variant="primaryContainer"
                />
              </div>
            </div>
            <p class="text-sm">
              Menangani retur secara otomatis, mendata alasan pengembalian, dan
              mengoptimalkan proses retur agar hemat waktu dan biaya
            </p>
          </div>
        </div>
      </UiCard>
    </div>
  </UiEffectMarquee>
</template>
